// extracted by mini-css-extract-plugin
export var buttons = "Buttons-module--buttons--2pNJD";